import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TableAHSF from "../../../Components/TableAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { CompletionRecommendationApplicationsButton } from "../../../Redux/Reducers/Manager/ScientificCommittee";
import { useEffect } from "react";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
// import { CompletionRecommendationApplicationsButton } from "../../../Redux/Reducers/Manager/ScientificCommittee";

const ScientificCommitteeRequsetTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lang = useSelector((state) => state.languageReducer.Language);

  const ScientificCommitteeRequsetTable = useSelector(
    (state) => state.ScientificCommittee.RecommendationScientificBodyButtons
  );
  const CompletionRecommendationApplications = useSelector(
    (state) => state.ScientificCommittee.CompletionRecommendationApplications
  );
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["tasksList"]
  );

  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);

  console.log(UserInfo, "UserInfo");

  console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  const validation = () => {
    const validationMassage = [];

    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      validationMassage.push(
        lang == "en"
          ? "Please select at least one request"
          : "الرجاء اختيار طلب واحد على الاقل"
      );

    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title:
          lang == "en"
            ? "Please fill in the following fields"
            : "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: ${
            lang == "en" ? "left" : "right"
          }; direction: ${lang == "en" ? "ltr" : "rtl"}; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${validationMassage
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: lang == "en" ? "Ok" : "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return false;
    }

    return true;
  };

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      NmaeColumnEN: "Application Number",
      TotalNumber: true,
    },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: " الاسم الكامل",
      NmaeColumnEN: "Full Name",
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل",
      NmaeColumnEN: "Field Name",
    },
    {
      KeyName: "subjectNAme",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      NmaeColumnEN: "Subject Name",
    },
    {
      KeyName: "recommindationName",
      ShowStatus: true,
      NmaeColumn: "التوصية",
      NmaeColumnEN: "Recommindation Name",
    },
    {
      KeyName: "noteNAme",
      ShowStatus: true,
      NmaeColumn: "الملاحظات",
      NmaeColumnEN: "Note Name",
    },
    {
      KeyName: "subTaskStatusName",
      ShowStatus: true,
      NmaeColumn: "الحالة",
      NmaeColumnEN: "Status ",
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        let value = JSON.parse(e.target.value).subTaskId;

        console.log(value, "value");

        navigate(
          `/ResearchersAward/manager/scientific/ScientificCommitteeRequsetTable/${value}`
        );
      },

      content: " ",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "",
      ShowStatus: false,
    },
    {
      Click: async (e) => {
        const result = JSON.parse(e.target.value)?.applicationInformationId;

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
    },
  ];

  const RequestsColumns = [];
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div></div>,
    maxWidth: "700px",
    maxHeight: "600px",
  };
  useEffect(() => {
    dispatch(setRefreshTable({ tableId: "ScientificCommitteeRequsetTable" }));
  }, [ScientificCommitteeRequsetTable, CompletionRecommendationApplications]);

  useEffect(() => {
    dispatch(SetArrayDataCheckBoks());
  }, []);
  console.log(
    arrayDataCheckBoks
      ?.map((ele) => ele.subTaskId)
      .includes("8c4ee6bd-442b-4258-8c68-d25e881b3e2d"),
    "arrayDataCheckBoks"
  );

  return (
    <>
      <TableAHSF
        tableId="ScientificCommitteeRequsetTable"
        culomEdite={culomEdite}
        lang={lang}
        uniqueValue=""
        valueButtonAction=""
        URL={`api/SubTask/GetAllSubTaskForScientificBodyAssigningByUserId`}
        UrlBody={{
          userId: UserInfo?.UserId,
          lang: lang == "en" ? true : false,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable="الطلبات"
        titelTableEN="Requests"
        selectRowNumber
        checkBoksColumName={lang == "en" ? "Select all" : "تحديد الكل"}
        sort
        pagination
        AppStatus
        tableBtn={false}
        sortTable
        keyNameSort="dateCreate"
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData
        hideIconsAction
        checkBoks
        uniqeKeyNameRedux="tasksList"
        uniqeKeyName="subTaskId"
        nameColumAction=""
        showIconsApplication
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        // checkBoksCustomRender={true}
        // checkBoksCustomRenderKeyName={"subTaskStatusId"}
        // checkBoksCustomRenderKeyValue={"c4796bd3-4f95-4c1e-957d-ddc57a532899"}

        checkBoksCustomRender={false}
        checkBoksCustomRenderKeyName={"subTaskStatusId"}
        checkBoksCustomRenderKeyValue={["8c4ee6bd-442b-4258-8c68-d25e881b3e2d"]}
        checkBoksCustomRenderShowOrHide={false}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle="معلومات الطلب"
      />

      <div className="containerButtonMAin">
        <ButtonAHSF
          type="submitter"
          fieldsName="AddRecomendation"
          lang={lang}
          text="إضافة التوصية على الطلبات"
          onClick={() => {
            if (validation()) {
              navigate(
                `/ResearchersAward/manager/scientific/ScientificCommitteeRequsetTable/view`
              );
            }
          }}
          disabled={false}
          title="اخذ اجراء"
          show={true}
        />
        {arrayDataCheckBoks?.length > 0 &&
          arrayDataCheckBoks != undefined &&
          arrayDataCheckBoks
            ?.map((ele) => ele.subTaskStatusId)
            .includes("91c8187c-cf60-4aec-a35e-261d5af84935") == false && (
            <>
              <div style={{ whiteSpace: "nowrap" }}>
                <ButtonAHSF
                  type="submitter"
                  fieldsName="FinishRecomendation"
                  lang={lang}
                  text="الإنتهاء من التوصية على الطلبات"
                  onClick={async () => {
                    if (validation()) {
                      try {
                        const result = await dispatch(
                          CompletionRecommendationApplicationsButton({
                            subTaskIdList: arrayDataCheckBoks.map(
                              (subTask) => subTask.subTaskId
                            ),
                          })
                        );
                        Swal.fire({
                          icon: "success",
                          title:
                            lang == "en"
                              ? "Completed successfully"
                              : "تم الإنهاء بنجاح",
                          text:
                            lang == "en"
                              ? "Recommendations on selected requests have been successfully sent."
                              : "تم إرسال التوصيات على الطلبات المختارة بنجاح.",
                          confirmButtonText: lang == "en" ? "Ok" : "حسناً",
                        });
                        dispatch(SetArrayDataCheckBoks());

                        console.log(
                          result,
                          "CompletionRecommendationApplications Result"
                        );
                      } catch (error) {
                        Swal.fire({
                          icon: "error",
                          title: lang == "en" ? "An error occurred" : "حدث خطأ",
                          text:
                            lang == "en"
                              ? "An error occurred while sending recommendations. Please try again later."
                              : "حدث خطأ أثناء إرسال التوصيات. حاول مرة أخرى لاحقًا.",
                          confirmButtonText: lang == "en" ? "Ok" : "حسناً",
                        });
                        console.error(
                          "Error dispatching completion action:",
                          error
                        );
                      }
                    }
                  }}
                  disabled={false}
                  title="اخذ اجراء"
                  show={true}
                />
              </div>
            </>
          )}
      </div>
    </>
  );
};

export default ScientificCommitteeRequsetTable;
